import { Injectable } from '@angular/core';
import {
  DataModel,
  MetaModel,
  WidgetModel,
} from 'common/models/utility-models/base-model';
import { FormWidgetService } from '../form-widget.service';
import { SystemService } from 'common/services/core-services/system.service';
import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import { TrainersMetaModel } from 'common/models/page-models/Trainers Model/trainers-form-meta.model';
import { TrainersFormDataService } from 'common/services/data-services/admin/trainer/trainers-form.data.service';
import { CategoryListDataService } from 'common/services/data-services/custom-service/categoryList-services';

@Injectable({
  providedIn: 'root',
})
export class TrainersFormWidgetService extends FormWidgetService<TrainersModel> {
  constructor(
    protected ds: TrainersFormDataService,
    private ss: SystemService,
    private category: CategoryListDataService
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new TrainersMetaModel();
    return meta.getMetaModel();
  }

  override prepareMetaModel(
    dataModel: TrainersModel,
    metaModel: TrainersMetaModel,
    routeData: WidgetModel
  ): Promise<TrainersMetaModel> {
    return new Promise<TrainersMetaModel>((resolve, reject) => {
      // metaModel.properties['categoryIds'].options = this.ss.dataStorage.category_name;
      this.category.postData({}).then((data) => {
        metaModel.properties['categoryIds'].options = data.details;
      });
      metaModel.pageTitle =
        dataModel.id !== '' ? 'Edit Trainers' : 'Add Trainer';
      resolve(metaModel);
    });
  }
}
